<template>
    <div
        class="mx-auto flex w-full max-w-[52rem] flex-col px-2 pb-4 sm:px-4 md:px-6
               xl:max-w-[58rem] 2xl:max-w-[64rem] 3xl:max-w-[80rem] 4xl:max-w-[80rem]"
    >
        <div class="glass-page grow">
            <header class="mb-5 sm:mb-6">
                <h1
                    v-text="name"
                    class="page-title"
                />

                <div class="mt-4 h-px w-24 bg-gradient-to-r from-foam/40 to-transparent" />
            </header>

            <div class="animate-fade-in">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    // Library
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'NormalPage',

        props: {
            name: {
                type: String,
                required: true,
            },
        },
    });
</script>
